import clsx from 'clsx';
import { ReactNode } from 'react';

import Avatar from 'src/components/avatar';
import { ContentToggleButtons } from 'src/components/buttons/content-toggle-buttons';
import { AssignmentsViewOptions } from 'src/interfaces/assignment.types';
import AuthService from 'src/services/api/auth.service';
import { useActiveAssignmentsViewSelector } from 'src/store/features';

import { JoinCodeModal } from './single-session-code';
import { SubjectsFilter } from './subjects-filter';

import './middle-school-view.scss';

const MiddleSchoolView = ({ children }: { children: ReactNode }) => {
  const isTeacher = AuthService.isTeacher();

  const activeAssignmentsView = useActiveAssignmentsViewSelector();

  // @TODO: implement subject filter for apps section and remove .middle-school-view__apps-filter-placeholder div
  return (
    <section className="middle-school-view" data-testid="middle-school-view">
      <div
        className={clsx('middle-school-view__content-wrapper', {
          'middle-school-view__content-wrapper--teacher': isTeacher,
        })}
      >
        <div
          className={clsx('middle-school-view__main-content', {
            'middle-school-view__main-content--teacher': isTeacher,
          })}
        >
          <div className="middle-school-view__top-section">
            <div className="middle-school-view__avatar-wrapper">
              <Avatar
                avatarClassNames={{
                  container: 'middle-school-view__avatar-container',
                  assets: 'middle-school-view__avatar-assets',
                  tooltip: 'middle-school-view__avatar-tooltip',
                }}
              />
            </div>
            <div className="middle-school-view__filters-wrapper">
              <ContentToggleButtons />
              {activeAssignmentsView !== AssignmentsViewOptions.APPS ? (
                <SubjectsFilter />
              ) : (
                <div className="middle-school-view__apps-filter-placeholder" />
              )}
            </div>
          </div>
          {children}
        </div>
        <JoinCodeModal />
      </div>
    </section>
  );
};

export default MiddleSchoolView;
